import type { ReactNode } from 'react'

/** The strip under a chart card's title: what the chart currently shows. Card actions stay in the header. */
export function SinkContextRow({ children }: { children: ReactNode }) {
  return (
    <div
      data-testid="sink-context-row"
      className="flex flex-wrap items-center gap-2 px-3 py-1.5 min-h-9 text-xs bg-base-200/60 border-b border-base-300"
    >
      {children}
    </div>
  )
}

export function TaxaBreadcrumb({ path, onBack, onReset }: { path: string[]; onBack?: () => void; onReset?: () => void }) {
  const atRoot = path.length === 0
  return (
    <>
      {onBack && (
        <button className="btn btn-xs btn-ghost" disabled={atRoot} onClick={onBack}>
          Back
        </button>
      )}
      {onReset && (
        <button className="btn btn-xs btn-ghost" disabled={atRoot} onClick={onReset}>
          Reset
        </button>
      )}
      <nav aria-label="Taxon path" className="flex flex-wrap items-center gap-1 opacity-80">
        {atRoot ? (
          <span>All taxa</span>
        ) : (
          path.map((taxon, i) => (
            <span key={`${i}:${taxon}`} className="flex items-center gap-1">
              {i > 0 && <span className="opacity-50">›</span>}
              <span className={i === path.length - 1 ? 'font-semibold' : ''}>{taxon}</span>
            </span>
          ))
        )}
      </nav>
    </>
  )
}
